import { css } from 'linaria';

export const assistiveText = css`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
`;

export const inputWrapper = css`
    margin: 5px 0;
    position: relative;
`;

export const icon = css`
    position: absolute;
    right: 0;
    top: 50%;
    transform: translate(-50%, -50%);
`;

export const fullWidth = css`
    width: 100%;
`;

export const disabled = css`
    opacity: 0.5;
`;
